// Define styling variables to match the SCSS inspiration
export const COLORS = {
  primary: '#e4b17a',
  primaryDark: '#c99b69',
  textPrimary: '#8c6b4a',
  textSecondary: '#a17c57',
  bgLight: '#fdf8f3',
  bgMedium: '#f9ede2',
  bgWhite: '#ffffff',
  green: '#10b981',
  gray: '#d1d5db',
  lightGray: '#f3f4f6'
};

// Add animation styles
export const animationStyles = {
  enter: 'transform-gpu scale-95 opacity-0',
  enterActive: 'transition-all duration-300 ease-out transform-gpu scale-100 opacity-100',
  exit: 'transform-gpu scale-100 opacity-100',
  exitActive: 'transition-all duration-200 ease-in transform-gpu scale-95 opacity-0',
  pinAppear: 'animate-pin-appear',
  scaleEntrance: 'animate-scale-entrance'
};

// Regrade polling constants
export const REGRADE_POLLING_INTERVAL = 5000; // Check every 5 seconds
export const MAX_POLLING_TIME = 120000; // Stop polling after 2 minutes (24 attempts)

// AI Learning polling constants (slower since it's a longer process)
export const AI_LEARNING_POLLING_INTERVAL = 15000; // Check every 15 seconds
export const AI_LEARNING_MAX_POLLING_TIME = 600000; // Stop polling after 10 minutes